module.exports = __webpack_public_path__ + "static/media/GESSTwo700.db387a36.woff";